import React from 'react';
import PropTypes from 'prop-types';
import Input from '../../../../../ui_kit/input/Input';

function InputWrapper(props) {
  const {
    input: {
      value, name, onChange, onFocus, onBlur,
    }, placeholder, label, type, className, icon, id, hint, disabled,
    meta: { touched, error }, autocomplete, prefix,
  } = props;
  return (
    <Input
      label={label}
      placeholder={placeholder}
      value={value}
      name={name}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      type={type}
      error={touched ? error : null}
      className={className}
      icon={icon}
      hint={hint}
      disabled={disabled}
      id={id}
      autocomplete={autocomplete}
      prefix={prefix}
    />
  );
}

InputWrapper.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
  }).isRequired,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string.isRequired,
  className: PropTypes.string,
  icon: PropTypes.node,
  hint: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  autocomplete: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  prefix: PropTypes.string,
};

export default InputWrapper;
